import { useApiQuery } from '@/modules/common';
import { PrinterType } from '@/modules/common/types';
import { GcrDetails } from '@/modules/gcrs/types';
import { useModelAttributes } from '@/modules/models';
import { Model } from '@/modules/models/types';

export function useFetchModelsData() {
  const { data: optionsData } = useModelAttributes();

  const { data: printers, isFetching: isPrintersFetching } = useApiQuery<
    PrinterType[]
  >('/printers', {
    queryKey: ['printers'],
    initialData: [],
  });

  const {
    isFetching: isFetchingGcrs,
    data: gcrs,
    refetch: refetchGcrs,
  } = useApiQuery<{
    items: GcrDetails[];
  }>('/gcrs?pageSize=1000', {
    queryKey: ['gcrs'],
    initialData: { items: [] },
  });

  const { isFetching, data } = useApiQuery<Model[]>('/models', {
    queryKey: ['models'],
    initialData: [],
  });

  return {
    gcrs,
    printers,
    optionsData,
    models: data,
    refetchGcrs,
    isFetching: isFetching || isFetchingGcrs || isPrintersFetching,
  } as const;
}
